import React, {useEffect} from 'react'

const GoogleAds = () => {

    useEffect(() => {
        window.googletag.cmd.push(function() {
            window.googletag.display('ad-slot');
        });
    }, [])

    return (
        <div id="ad-slot">
            
        </div>
    )
}

export default GoogleAds
